import React, { useState, useEffect } from 'react';
import BasePage from '../../components/BasePage';
import Input from '../../components/FormElements/Input';
import { format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { toast, ToastContainer } from 'react-toastify';
import { callAPI } from '../../hooks/CallAPI';
import { useNavigate, Navigate } from "react-router-dom"; // Si vous utilisez React Router pour la navigation
import LoadingWrapper from '../../components/LoadingWrapper'; // Assurez-vous que le chemin est correct


const EditCoordonnees = (props) => {
    const [data, setData] = useState(null);
    const [user] = useLocalStorage("user", null);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const [hasChanged, setHasChanged] = useState(false);

    const [changedFields, setChangedFields] = useState({}); // État pour suivre les champs modifiés

    const fields = [
        {
            key: 'civilite',
            name: 'Civilité',
            type: 'select',
            options: [
                { id: "M", name: "Monsieur" },
                { id: "Mme", name: "Madame" }
            ]

        }, {
            key: 'nom',
            name: 'Nom',
        }, {
            key: 'prenom',
            name: 'Prénom',
        }, {
            key: 'date_naissance',
            name: 'Date de naissance',
            type: 'date'
        }, {
            key: 'fonction_id',
            name: 'Fonction',
            type: 'select',
            options: data ? data.fonctions : []
        }, {
            key: 'mails',
            single_key: 'mail',
            name: 'Email',
        }, {
            key: 'phones',
            format: 'phone',
            single_key: 'phone',
            name: 'Téléphone',
        },
        {
            key: 'adresse',
            name: 'Adresse',
        }, {
            key: 'code_postal',
            name: 'Code Postal',
        }, {
            key: 'ville',
            name: 'Ville',
        },
        {
            key: 'siren',
            name: 'Code Siren',
        },
        {
            key: 'rib',
            name: 'RIB',
            type: 'file'
        }
    ]

    const getInitialFormState = (data = {}) => {
        const initialState = {};

        fields.forEach(field => {
            let val = '';
            console.log(Object.keys(data).length);
            // if (Object.keys(data).length !== 0 && data.constructor === Object) {

            switch (field.key) {
                case 'mails':
                case 'phones':
                    val = data && data.contact && data.contact[field.key] ? data.contact[field.key] : []
                    break;

                case 'adresse':
                case 'code_postal':
                case 'ville':
                case 'siren':
                    val = data && data.entreprise && data.entreprise[0] && data.entreprise[0][field.key] ? data.entreprise[0][field.key] : '';
                    break;

                default:
                    val = data && data.contact && data.contact[field.key] ? data.contact[field.key] : ''
                    break;
            }
            // }

            initialState[field.key] = val
        });
        return initialState;
    };

    const [form, setForm] = useState(getInitialFormState);
    const [originalForm, setOriginalForm] = useState(getInitialFormState);


    const handleChange = (key, value, index = null) => {
        setForm((prevForm) => {
            let updatedForm = { ...prevForm };

            if (index !== null) {
                // Pour les champs avec des tableaux (ex : mails, phones)
                const updatedArray = [...updatedForm[key]];
                updatedArray[index] = { ...updatedArray[index], [fields.find(f => f.key === key).single_key]: value };
                updatedForm[key] = updatedArray;
            } else {
                updatedForm[key] = value;
            }

            // Mettre à jour les champs modifiés
            setChangedFields((prevChangedFields) => ({
                ...prevChangedFields,
                [key]: value,  // Stocke uniquement les champs modifiés
            }));

            return updatedForm;
        });
    };

    useEffect(() => {
        if (data) {
            const initialFormState = getInitialFormState(data);
            setForm(initialFormState);
            setOriginalForm(initialFormState);
        }
    }, [data]);

    useEffect(() => {
        // Compare form with originalForm
        const isFormDifferent = JSON.stringify(form) !== JSON.stringify(originalForm);
        setHasChanged(isFormDifferent)
        console.log("Form is different:", hasChanged);
    })

    useEffect(() => {
        // Redirect if there's an existing update_coords
        if (data && data.update_coords) {
            toast.info("Une demande de modification est déjà en cours.");
            navigate("/coordonnees", { replace: true });
        }
    }, [data, navigate]);


    const validateForm = () => {
        for (let field of fields) {
            if (field.key === 'mails' || field.key === 'phones') {
                for (let item of form[field.key]) {
                    if (!item[field.single_key] || item[field.single_key].trim() == '') {
                        toast.warning(`Veuillez remplir tous les champs ${field.name}`);
                        return false;
                    }
                }
            } else if (field.type === 'file') {
                // Vérifie les champs de type 'file', mais ne les rend pas obligatoires
                if (form[field.key] && form[field.key].name) {
                    // Si un fichier est sélectionné, on valide que ce fichier existe
                    if (!form[field.key]) {
                        toast.warning(`Veuillez sélectionner un fichier pour ${field.name}`);
                        return false;
                    }
                }
                // Vérification pour les champs normaux
            } else {
                if (!form[field.key] || form[field.key].trim() == '') {
                    toast.warning(`Veuillez remplir le champ ${field.name}`);
                    return false;
                }
            }
        }
        return true;
    };

    const acceptedFileTypes = ['pdf', 'png', 'jpg', 'jpeg', 'gif'];

    // Selectionner le ficher RIB
    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        const maxSize = 5 * 1024 * 1024; // 5MB
        
        try {
            // Validation du fichier
            if (!file) return;
            console.log(file);

            const fileType = file.type.split('/')[1] || file.name.split('.').pop().toLowerCase();

            if (!acceptedFileTypes.includes(fileType)) {
                toast.error(`Le fichier doit être au format: ${acceptedFileTypes.join(', ')}`);
                return;
            }
            if (file.size > maxSize) {
                toast.error('Le fichier est trop volumineux (max 5MB)');
                return;
            }

            const reader = new FileReader();
            reader.onloadend = () => {
                const base64File = reader.result.split(',')[1];
                handleChange('rib', base64File);
            };
            reader.onerror = () => {
                toast.error('Erreur lors de la lecture du fichier');
            };
            reader.readAsDataURL(file);
        } catch (error) {
            toast.error('Erreur lors du traitement du fichier');
            console.error(error);
        }
    };

    const handleSendModifs = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setIsLoading(true);

        // Créer un objet qui contient uniquement les champs modifiés
        const modifiedData = {};
        for (let key in changedFields) {
            if (changedFields.hasOwnProperty(key)) {
                // Vérifiez si le champ a été modifié en comparant avec l'état original
                if (changedFields[key] !== originalForm[key]) {
                    modifiedData[key] = changedFields[key];
                }
            }
        }

        // Récupérer le fichier RIB (si existant)
        const dataToSend = {
            form: form, // Formulaire complet
            modifiedData: modifiedData, // Données modifiées
        };

        // Ajouter le fichier RIB en base64 si disponible
        if (form.rib) {
            dataToSend.rib = form.rib; // Ajouter le RIB encodé en base64
        }

        // Envoie les deux : le formulaire complet et les champs modifiés
        const responseData = await callAPI('/update-coords', {
                access_token: user.access_token,
                form: form,
                modifiedData: modifiedData
        });
        setIsLoading(false);

        if (responseData.success === true) {
            navigate('/coordonnees');
        }
    };

    const content = (data) => {
        setData(data);
        console.log(data);
        // Utilisez la variable data récupérée dans BasePage ici
        // Par exemple, vous pouvez afficher les données ou effectuer toute autre logique avec elles
        if (!data) {
            return false;
        }

        return (
            <div id="" className="">
                <div className="bloc-info my-3 mt-8 flex justify-between items-center">
                    <div className="leading-normal">
                        Vous pouvez faire une demande de modification de vos données personnelles, notre <strong>Service Administration</strong> se chargera de les mettre à jour dans les plus brefs délais
                    </div>
                </div>

                <form action="" className="mt-14" onSubmit={handleSendModifs} method="POST" enctype="multipart/form-data">
                    {fields.map((f) => (
                        (() => {
                            // Vérifie si la clé est 'mails' ou 'phones'
                            if (f.key === 'mails' || f.key === 'phones') {
                                if (data) {
                                    // console.log(data, form);
                                    return form[f.key].map((item, index) => (
                                        <Input
                                            key={`${f.key}-${index}`}
                                            name={`${f.key}-${index}`}
                                            label={`${item.libelle_name ?? f.name + ' ' + (index + 1)}`}
                                            value={item[f.single_key]}
                                            type="text"
                                            onChange={(e) => handleChange(f.key, e.target.value, index)}
                                        />
                                    ));
                                }
                            }

                            // Vérifie si la clé est 'rib'
                            if (f.key === 'rib') {
                                return (
                                    <Input
                                        key={f.key}
                                        name={f.key}
                                        label={f.name}
                                        type="file"
                                        onChange={handleFileChange}
                                    />
                                );
                            }

                            // Pour tous les autres champs
                            return (
                                <Input
                                    key={f.key}
                                    name={f.key}
                                    label={f.name}
                                    value={form[f.key]}
                                    type={f.type ?? 'text'}
                                    options={f.options ?? null}
                                    onChange={(e) => handleChange(f.key, e.target.value)}
                                />
                            );
                        })()
                    ))}
                    <div className="relative">
                        <button type="submit" disabled={!hasChanged} className="bg-mlime px-6 py-4 rounded-3xl w-full max-w-lg flex items-center justify-center text-white font-bold text-center m-auto  duration-500 hover:bg-colorbutton">
                            <LoadingWrapper isLoading={isLoading}>
                                Envoyer mes modifications <FontAwesomeIcon className="ml-3 text-2xl" icon="fa-regular fa-paper-plane" />
                            </LoadingWrapper>
                        </button>
                    </div>
                </form>
            </div>
        );
    };

    return <BasePage content={content} title="Modifier mes informations" />;
}

export default EditCoordonnees;